import { createMakeStyles } from 'tss-react'
import { useTheme } from '@mui/material/styles'

export const { makeStyles } = createMakeStyles({ useTheme })
